
export class FileStatusModel {
    Role: string;
    FileStatusId: number;
    customerListDDL: any[];
    selectOptionDDL: any;
    statusListDDL: any[];
    selectStatusDDL: any;

    constructor(Role: string, FileStatusId: number, customerListDDL: any[], selectOptionDDL: any, statusListDDL: any[], selectStatusDDL: any) {
        this.Role = Role;
        this.FileStatusId = FileStatusId;
        this.customerListDDL = customerListDDL;
        this.selectOptionDDL = selectOptionDDL;
        this.statusListDDL = statusListDDL;
        this.selectStatusDDL = selectStatusDDL;
    }
}


// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/model/file-status.model.ts